import React, {useCallback, useMemo} from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Box, Button,
  Checkbox,
  FormControl,
  FormControlLabel,
} from "@material-ui/core";
import { useAllClients } from "../../../../hooks/useAllClients";
import { DateRangeFilter } from "../../../../components/table/toolbar/DateRangeFilter";
import { useDateRangeState } from "./useDateRangeState";
import { Autocomplete } from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import { Client } from "../../../../api/api";

export interface SettingReportsForm {
  volumeReport: boolean;
  markupReport: boolean;
  feeReport: boolean;
  portfolioId: number;
  groupByDay: boolean;
  groupByInstrument: boolean;
  groupByAsset: boolean;
  groupByTermAsset: boolean;
  groupByAssetClass: boolean;
  fromDateTime: string;
  toDateTime: string;
}

export interface SettingReportsProps {
  onSubmit: (date: SettingReportsForm) => void
}

export const SettingReports = (p: SettingReportsProps) => {
  const {clients} = useAllClients(),
    {start, finish, onChange} = useDateRangeState();

  const defaultValues = useMemo(() => ({
    fromDateTime: start.toISO(),
    toDateTime: finish.toISO()
  }), [finish, start])

  const { register, handleSubmit, control } = useForm<SettingReportsForm>({defaultValues});

  const onSubmit = useCallback((data: SettingReportsForm) => {
    const fromDateTime = start.toISO(),
        toDateTime = finish.toISO();
    p.onSubmit({...data, fromDateTime, toDateTime })
  }, [finish, p, start])

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>

        <Controller
          name="portfolioId"
          as={
            <Autocomplete<Client>
              options={clients||[]}
              getOptionLabel={ o => o.name}
              renderInput={ params => (
                <TextField {...params} label="Client" />
              )}/>
          }
          control={control}
          onChange={([, data]) => data?.clientPortfolioId}
        />
        <FormControl margin="dense" fullWidth>
          <FormControlLabel
            label="Volume Report"
            control={<Checkbox name={"volumeReport"} inputRef={register} color="primary" />}
          />
        </FormControl>
        <FormControl margin="dense" fullWidth>
          <FormControlLabel
            label="Markup Report"
            control={<Checkbox name={"markupReport"} inputRef={register} color="primary" />}
          />
        </FormControl>
        <FormControl margin="dense" fullWidth>
          <FormControlLabel
            label="Fee Report"
            control={<Checkbox name={"feeReport"} inputRef={register} color="primary" />}
          />
        </FormControl>
        <DateRangeFilter fullWidth start={start} finish={finish} onChange={onChange} />
        <FormControl margin="dense" fullWidth>
          <FormControlLabel
            label="Group by day"
            name="groupByDay"
            inputRef={register}
            control={<Checkbox color="primary" />}
          />
        </FormControl>
        <FormControl margin="dense" fullWidth>
          <FormControlLabel
            label="Group by instrument"
            control={<Checkbox name={"groupByInstrument"} inputRef={register} color="primary" />}
          />
        </FormControl>
        <FormControl margin="dense" fullWidth>
          <FormControlLabel
            label="Group by asset"
            control={<Checkbox name={"groupByAsset"} inputRef={register} color="primary" />}
          />
        </FormControl>
        <FormControl margin="dense" fullWidth>
          <FormControlLabel
            label="Group by term asset"
            control={<Checkbox name={"groupByTermAsset"} inputRef={register} color="primary" />}
          />
        </FormControl>
        <FormControl margin="dense" fullWidth>
          <FormControlLabel
            label="Group by asset class"
            control={<Checkbox name={"groupByAssetClass"} inputRef={register} color="primary" />}
          />
        </FormControl>
        <Box mt={1}/>
        <Button fullWidth type='submit' color='primary' variant='contained'>
          Submit
        </Button>
      </form>
    </>
  );
};
